<template>
  <div>

    <v-layout class="t-balance-list-header">
      <v-flex xs3 class="text-xs-center pr-1">Сумма</v-flex>
      <v-flex xs3 class="text-xs-center pr-1">Ед.изм.</v-flex>
      <v-flex xs3 class="text-xs-center pr-1">Итого</v-flex>
      <v-flex xs3 class="text-xs-center pr-1">Движение</v-flex>
    </v-layout>

    <v-list three-line class="t-balance-list">
      <template v-for="(document, index) in content">
        <div :key="index">
          <v-divider></v-divider>
          <v-list-tile :class="{'red--text': document.dc == 0, 'green--text': document.dc == 1}" class="document-line">
            <v-list-tile-content @click="openDocument(document)">
              <v-list-tile-title class="pl-3">{{ document.title }} № {{ document.doc_id}}</v-list-tile-title>
              <v-list-tile-sub-title class="pl-3 mb-3">{{ document.created_on }}</v-list-tile-sub-title>
              <v-list-tile-sub-title class="text--primary">
                <v-layout class="document-stats" :class="{'red--text': document.dc == 0, 'green--text': document.dc == 1}">
                  <v-flex xs3 class="text-xs-right pr-1">
                    {{document.summa}}
                    <span class="grey--text currency">{{currencies[document.valuti_id]}}</span>
                  </v-flex>
                  <v-flex xs3 class="text-xs-right pr-1">{{document.kurs}}</v-flex>
                  <v-flex xs3 class="text-xs-right pr-1">{{document.itog}}</v-flex>
                  <v-flex xs3 class="text-xs-right pr-1">{{ document.balance | numberFormat(2, '.', ' ') }}</v-flex>
                </v-layout>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </div>
      </template>
      <v-divider v-if="content.length"></v-divider>
    </v-list>
  </div>
</template>

<script>
import balanceDisplay from '../mixins/balanceDisplay'

export default {
  name: 'BalanceList',
  mixins: [
    balanceDisplay
  ]
}
</script>

<style lang="stylus">
  .t-balance-list {
    padding-top: 0;
    .v-list__tile {
      padding: 0;
    }
  }
  .t-balance-list-header {
    > div {
      padding: 5px 0;
      border-right: 1px solid rgba(0, 0, 0, 0.12);
      border-top: 1px solid rgba(0, 0, 0, 0.12);

      &:last-child {
        border-right: none
      }
    }
  }
  .document-stats {
    > div {
      border-top: 1px solid rgba(0, 0, 0, 0.12);
      border-right: 1px solid rgba(0, 0, 0, 0.12);

      &:last-child {
        border-right: none
      }
    }
  }
</style>
